import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Tab,
  Tabs,
  Typography,
  TablePagination,
} from "@mui/material";
import { useLoading } from "../../../common/LoadingContext";
import { useNotificationContext } from "../../../common/NotificationContext";
import BroadCast from "./BroadCast";
import ServiceAdv from "./ServiceAdv";
import Spare from "./Spare";
import TechDoc from "./TechDoc";
import {
  NotificationService,
  getNotificationCountService,
} from "../../../services/NotificationService";
import useGlobalState from "../../../Context";
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, ml: 2 }}>{children}</Box>}
    </div>
  );
};

const Read = ({state}) => {
  const [{ auth }, dispatch] = useGlobalState();
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [value, setValue] = React.useState(0);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [notificationRecords, setNotificationRecords] = useState([]);
  const [totalElements, setTotalElements] = useState();
  const [broadcastTotalLength, setBraodTotalCastLength] = useState(0);
  const [serviceTotalAdvLength, setServTotalAdvLength] = useState(0);
  const [spareTotalLength, setSpareTotalLength] = useState(0);
  const [tecDocTotalLength, setTechTotalDocLength] = useState(0);
  const loginUserType = auth?.ldapParam?.userType;
  
  const handleChange = (e, newValue) => {
    setPage(0);
    fetchNotificationList(0, newValue);      
    setValue(newValue);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(5);
  };
  const USERID = auth?.ldapParam?.userId;
  const DEPTID = auth?.ldapParam?.deptId;
  
  useEffect(() => {
    if (state) {
      setValue(state?.typeId);
      fetchNotificationList(0,state?.typeId)
    }
    else{
      fetchNotificationList();
    }
  }, []);

 
  const handleTableChanges = async (paginationValues, isUpdate) => {
    try {
      setLoading(true);
      const requestObj = {
        userId: USERID,
        userType: loginUserType, 
        notificationType: value ? value : 0,
        fetchPageRequest: {
          pageNumber: paginationValues?.pageNumber ?? 0,
          pageSize: paginationValues?.pageSize ?? 10,
          sortDirection: "DESC",
          sortBy: null,
          filterSearch: null,
          active: loginUserType === "Main Admin" ? 2 : 0,
        },
        deptId: DEPTID,
        read: true,
      };
      const notificationResponse = await NotificationService(requestObj);

      if (notificationResponse.statusCode == "6") {
        if (isUpdate) {
          setNotificationRecords([
            ...notificationRecords,
            ...notificationResponse.data.fetchNotificationResponses.content,
          ]);
          setTotalElements(
            notificationResponse?.data.fetchNotificationResponses.totalElements
          );
        } else {
          setNotificationRecords(
            notificationResponse.data.fetchNotificationResponses.content
          );
          setTotalElements(
            notificationResponse?.data.fetchNotificationResponses.totalElements
          );
        }
      } else {
        showNotification("Error", notificationResponse.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      //setTableLoader(false);
    }
  };

  const fetchNotificationList = async (page, notificationType) => {
    try {
      setLoading(true);
      const requestObj = {
        userId: USERID,
        userType: loginUserType,  
        notificationType: notificationType ? notificationType : 0,
        fetchPageRequest: {
          pageSize: 5,
          pageNumber: page ? page : 0,
          sortDirection: "DESC",
          sortBy: null,
          filterSearch: null,
          active: loginUserType === "Main Admin" ? 2 : 0,
        },
        deptId: DEPTID,
        read: true,
      };
      const notificationResponse = await NotificationService(requestObj);
      if (notificationResponse.statusCode === 6) {
        setBraodTotalCastLength(
          notificationResponse.data.notificationCountResponse.broadcastCount
        );
        setServTotalAdvLength(
          notificationResponse.data.notificationCountResponse.serviceAdvCount
        );
        setSpareTotalLength(
          notificationResponse.data.notificationCountResponse.spareCount
        );
        setTechTotalDocLength(
          notificationResponse.data.notificationCountResponse.techDocCount
        );

        setNotificationRecords(
          notificationResponse?.data.fetchNotificationResponses.content
        );
        setTotalElements(
          notificationResponse?.data.fetchNotificationResponses.totalElements
        );
      } else {
        showNotification("Error", notificationResponse.message, "error");
      }
    } catch (err) {
      showNotification(
        "Error",
        err.message ?? "Failed to fetch notification details"
      );
    } finally {
      setLoading(false);
    }
  };
  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    await handleTableChanges(paginationValues, false);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      

      await handleTableChanges(paginationValues, true);
    }
    setPage(newPage);
  };

  const TabWithCount = ({ children, count }) => {
    return (
      <Box sx={{ display: "inline-flex", alignItems: "center" }}>
        <Typography component="div">{children}</Typography>
        {count ? (
          <Typography
            component="div"
            variant="body2"
            sx={{ marginLeft: "0.5rem", fontSize: "1rem" }}
          >
            {count}
          </Typography>
        ) : null}
      </Box>
    );
  };
  return (
    <>
      <Paper elevation={4} sx={{ width: "100%", overflow: "hidden" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          aria-label="full width tabs example"
          centered
          className="notificationBlock"
        >
          <Tab
            label={
              <TabWithCount count={`( ${broadcastTotalLength} )`}>
                Broadcast
              </TabWithCount>
            }
          />
          <Tab
            label={
              <TabWithCount count={`( ${serviceTotalAdvLength} )`}>
                Service Adv
              </TabWithCount>
            }
          />
          <Tab
            label={
              <TabWithCount count={`( ${spareTotalLength} )`}>
                Spare
              </TabWithCount>
            }
          />
          <Tab
            label={
              <TabWithCount count={`( ${tecDocTotalLength} )`}>
                Technical Doc
              </TabWithCount>
            }
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          <BroadCast
            notificationRecords={notificationRecords}
            totalElements={totalElements}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            page={page}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ServiceAdv
            notificationRecords={notificationRecords}
            totalElements={totalElements}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            page={page}
          />
        </TabPanel>

        <TabPanel value={value} index={2}>
          <Spare
            notificationRecords={notificationRecords}
            totalElements={totalElements}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            page={page}
          />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <TechDoc
            notificationRecords={notificationRecords}
            totalElements={totalElements}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            page={page}
          />
        </TabPanel>
        {notificationRecords && totalElements > 5 ? (
          <TablePagination
            className="newPagination"
            rowsPerPageOptions={[5, 10, 50, 100]}
            component="div"
            count={totalElements}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        ) : null}
      </Paper>
    </>
  );
};

export default Read;
